/* global LayoutBuilderUI */

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { getRootReducer } from 'LayoutBuilderUI/reducers/rootReducer';
// @ts-expect-error not migrated yet
import { getApiClient } from 'interframe/proxy/api-request-proxy';
import postMessageMiddleware from 'LayoutBuilderUI/middleware/postMessageMiddleware';

// Set up Redux dev tools - https://github.com/zalmoxisus/redux-devtools-extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default function configureStore(initialState) {
  // @ts-expect-error cannot find name LayoutBuilderUI
  const httpClient = getApiClient(LayoutBuilderUI.messenger);
  const middlewares = [postMessageMiddleware];
  const createStoreWithMiddleware = composeEnhancers(applyMiddleware(thunk.withExtraArgument({
    httpClient
  })), applyMiddleware(thunk, ...middlewares.filter(m => m)))(createStore);
  return createStoreWithMiddleware(getRootReducer(initialState), initialState);
}